export const RED = "RED";
export const BLUE = "BLUE";

export function color(type=RED,data = {}) {
    return {
        type,
        data: data
    }
}
